<div class="chart-container">
  <canvas baseChart
    [type]="'bar'"
    [datasets]="datasets()"
    [labels]="labels()"
    [options]="chartOptions()"
    [plugins]="chartPlugins">
  </canvas>
</div>
